// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsCounter_container__3CiT5"};